var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo, useCallback, useState, useEffect, useRef } from 'react';
import { useUpdate } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
const prefixCls = createPrefixCls('checkbox-group');
export const CheckboxGroup = (_a) => {
    var { children, className, disabled, layout = 'between', checked, defaultChecked, onChange, formValue, setFormValue } = _a, restProps = __rest(_a, ["children", "className", "disabled", "layout", "checked", "defaultChecked", "onChange", "formValue", "setFormValue"]);
    const defaultCheckedRef = useRef(defaultChecked);
    const getPropsChecked = useMemo(() => {
        if (formValue !== undefined) {
            return formValue;
        }
        else if (checked !== undefined) {
            return checked;
        }
        else {
            return undefined;
        }
    }, [checked, formValue]);
    const [val, setVal] = useState(getPropsChecked === undefined ? defaultCheckedRef.current || undefined : getPropsChecked);
    useEffect(() => {
        if (setFormValue) {
            if (getPropsChecked !== undefined) {
                setFormValue(checked);
            }
            else if (defaultCheckedRef.current !== undefined) {
                setFormValue(defaultCheckedRef.current);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useUpdate(() => {
        setVal(getPropsChecked);
        if (setFormValue && getPropsChecked !== undefined) {
            setFormValue(getPropsChecked);
        }
    }, [getPropsChecked]);
    const handleChildChange = useCallback((childChecked, childValue) => {
        if (!disabled) {
            const prevValue = checked === undefined ? val : checked;
            let nextValue;
            if (childChecked) {
                if (prevValue) {
                    if (prevValue.includes(childValue)) {
                        nextValue = prevValue;
                    }
                    else {
                        nextValue = [...prevValue, childValue];
                    }
                }
                else {
                    nextValue = [childValue];
                }
            }
            else {
                if (prevValue) {
                    if (prevValue.includes(childValue)) {
                        nextValue = prevValue.filter((el) => el !== childValue);
                    }
                    else {
                        nextValue = prevValue;
                    }
                }
                else {
                    nextValue = prevValue;
                }
            }
            setVal(nextValue);
            onChange && onChange(nextValue);
            setFormValue && setFormValue(nextValue);
        }
    }, [checked, disabled, onChange, setFormValue, val]);
    const checkboxGroupCls = useMemo(() => {
        return classnames([prefixCls(), prefixCls(layout), className]);
    }, [className, layout]);
    return (React.createElement("div", Object.assign({ className: checkboxGroupCls }, restProps), React.Children.map(children, (child) => {
        return React.cloneElement(child, Object.assign({ groupValue: checked === undefined ? val : checked, onChange: handleChildChange }, (disabled ? { disabled } : {})));
    })));
};
export default CheckboxGroup;
